var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMxn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9994 12.268C23.9994 7.51049 21.2307 3.39974 17.2168 1.45874V23.0773C21.2307 21.1363 23.9994 17.0256 23.9994 12.268Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.268C0 17.0256 2.76867 21.1363 6.78262 23.0773V1.45874C2.76867 3.39974 0 7.51049 0 12.268Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87109 12.2678C8.87109 13.9967 10.2727 15.3983 12.0015 15.3983C13.7304 15.3983 15.132 13.9967 15.132 12.2678V11.2244H8.87109V12.2678Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1721 10.1819H13.0416C13.0416 9.60563 12.5744 9.13843 11.9982 9.13843C11.4219 9.13843 10.9547 9.60563 10.9547 10.1819H7.82422C7.82422 10.7582 8.3262 11.2254 8.90244 11.2254H8.8677C8.8677 11.8017 9.33486 12.2689 9.91119 12.2689C9.91119 12.8452 10.3783 13.3124 10.9547 13.3124H13.0416C13.618 13.3124 14.0851 12.8452 14.0851 12.2689C14.6615 12.2689 15.1286 11.8017 15.1286 11.2254H15.0938C15.6702 11.2254 16.1721 10.7582 16.1721 10.1819Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMxn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MXN.2ee57e49c424b165ef50400139b3b97b.svg";